// extracted by mini-css-extract-plugin
export default {"wrapper":"series_wrapper__eWBeX","icon":"series_icon__4TVRS","body":"series_body__Fnd-c","item":"series_item__JO3Tl"};